import { Axios } from "@/services/_axios";
import desktopManager from "./mixDesktop";
export default {
  data() {
    return {
      _savetimer: null,
    };
  },
  computed: {
    lastDesk() {
      return this.$store.state.user.settings.lastDesk;
      if (last != "0") return true;
      return false;
    },
    doneLoadDesks() {
      return this.$store.state.desktop.doneLoadDesks;
    },
  },
  methods: {
    __saveLastDesk() {
      return desktopManager.methods.saveCurrentDesktop(true, "RECENT");

      let currentDesktop = this.$store.state.desktop.currentDesktop;
      return desktopManager.methods.saveCurrentDesktop(
        currentDesktop == "",
        currentDesktop || "RECENT",
        false
      );
    },
    setDesktopEventUnload(added) {
      if (added === true) {
        window.addEventListener("beforeunload", this.__saveLastDesk);
        window.addEventListener("unload", this.__saveLastDesk);
      } else {
        window.removeEventListener("beforeunload", this.__saveLastDesk);
        window.removeEventListener("unload", this.__saveLastDesk);
      }
    },
    startDesktopSaveInterval(save) {
      if (save === undefined) save = this.lastDesk;
      clearInterval(this._savetimer);
      if (save) {
        this._savetimer = setInterval(() => {
          this.__saveLastDesk();
          // console.log("saving desk");
        }, 15000);
      }
      this.setDesktopEventUnload(!save);
    },
  },
  watch: {
    lastDesk(nval) {
      if (this.$store.state.desktop.doneLoadDesks) {
        this.startDesktopSaveInterval(nval);
      } /* clearInterval(this._savetimer);
      if (nval) {
        this._savetimer = setInterval(() => {
          this.__saveLastDesk();
        }, 15000);
      }
      this.setDesktopEventUnload(!nval); */
    },
    async doneLoadDesks(nval) {
      if (globalThis.ELECTRON_ENV) {
        // if we in electron env and this is new clean tab the load home page
        //get tab data from db
        let data = null;
        if (this.lastDesk)
          data = (await Axios.get("/api/user/usertoolbartabs/current")).data;
        //if we have tab data then load it now
        if (data && data.data) {
          if (Number(this.$store.state.otzar_version) < 22)
            if (!this.lastDesk) return;

          //we have tab data
          this.openDesktop({ data: data.data, title: "RECENT" });
          this.startDesktopSaveInterval();
        }

        //if not return here with welcome page
        this.startDesktopSaveInterval();
        return;
      }
      if (nval) {
        if (this.$route.path == "/" || this.$route.name == "book") {
          if (this.$_mobile && this.$store.state.desktop.desktops.length == 0)
            this.openInitBook(103967);

          let def = this.$store.state.desktop.desktops.find(
            (a) => a.default == 1
          );

          if (!def && !this.lastDesk) return;

          let last = this.$store.state.desktop.desktops.find(
            (a) => a.title == "RECENT"
          );

          if (!def && !last) return;

          let openDesk = def ? def : last;
          if (!openDesk) return;
          this.openDesktop(openDesk);

          this.startDesktopSaveInterval();
        }
      }
    },
  },
  created() {
    this.setDesktopEventUnload(!this.lastDesk);
    if (globalThis.SET_LAST_DESKTOP) {
      globalThis.SET_LAST_DESKTOP(this.__saveLastDesk);
      //create timer for lastdesk in case of unexcepted exit

      this._savetimer = setInterval(() => {
        this.__saveLastDesk();
      }, 15000);
    }
  },
};
